import {Endpoint} from '@eryxcoop/appyx-comm';
import DateAdapter from "../../adapters/DateAdapter";

export default class EditOrderEndpoint extends Endpoint {

  adaptValues({ordersNumber, order}) {
    const dateAdapter = new DateAdapter();
    return {
      "orders_number": ordersNumber,
      "delivery_site": {
        "name": order.deliverySiteName,
        "address": order.deliverySiteAddress,
        "city": order.deliverySiteCity,
      },
      "delivery_date": dateAdapter.adapt(order.deliveryDate),
      "purchase_orders_number": order.purchaseOrderNumber,
    }
  }
}